/* HWS24 – kleine, ruhige Interaktionen ohne externe Bibliotheken.
   Alles respektiert „Bewegung reduzieren“ und funktioniert ohne JS weiter. */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.__hwsReady = true;
  const strings = Object.assign({ locale: 'de', toDark: 'Dunkles Design aktivieren', toLight: 'Helles Design aktivieren', orderWithin: 'Bestelle in <strong>__TIME__</strong> – Versand noch heute', shipsOn: 'Versand am <strong>__DATE__</strong>', estimate: 'Lieferung voraussichtlich __FROM__ – __TO__ (DHL, Deutschland)', hours: 'Std.', minutes: 'Min.' }, window.hwsStrings || {});
  const dateLocale = strings.locale === 'en' ? 'en-GB' : 'de-DE';

  /* ---------- Bilder sanft einblenden, sobald geladen ---------- */
  function initFadeImages(root = document) {
    root.querySelectorAll('img.hws-fade-img:not(.is-loaded)').forEach((img) => {
      const done = () => img.classList.add('is-loaded');
      if (img.complete && img.naturalWidth > 0) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  /* ---------- USP-Leiste: Hinweise rotieren (pausiert bei Hover/Fokus) ---------- */
  function initUspBar(root = document) {
    root.querySelectorAll('[data-hws-usp]').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      const items = Array.from(bar.querySelectorAll('.hws-usp__item'));
      if (!items.length) return;
      items[0].classList.add('is-active');
      if (items.length < 2) return;
      let index = 0;
      let paused = false;
      bar.addEventListener('mouseenter', () => (paused = true));
      bar.addEventListener('mouseleave', () => (paused = false));
      bar.addEventListener('focusin', () => (paused = true));
      bar.addEventListener('focusout', () => (paused = false));
      setInterval(() => {
        if (paused || document.hidden) return;
        const current = items[index];
        index = (index + 1) % items.length;
        const next = items[index];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        setTimeout(() => current.classList.remove('is-leaving'), 650);
      }, 2500);
    });
  }

  /* ---------- Zahlen hochzählen, sobald sichtbar ---------- */
  function formatNumber(value, decimals) {
    return value.toLocaleString(dateLocale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }

  function initCounters(root = document) {
    const counters = root.querySelectorAll('[data-hws-count]:not([data-ready])');
    if (!counters.length) return;
    const run = (el) => {
      el.dataset.ready = '1';
      const target = parseFloat(el.dataset.hwsCount);
      const decimals = parseInt(el.dataset.decimals || '0', 10);
      const output = el.querySelector('[data-hws-count-value]') || el;
      if (reduceMotion || Number.isNaN(target)) {
        output.textContent = formatNumber(target, decimals);
        return;
      }
      const duration = 1400;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        output.textContent = formatNumber(target * eased, decimals);
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) return counters.forEach(run);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          run(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach((el) => {
      // Startwert setzen, damit beim Hochzählen nichts springt
      const output = el.querySelector('[data-hws-count-value]') || el;
      if (!reduceMotion) output.textContent = formatNumber(0, parseInt(el.dataset.decimals || '0', 10));
      observer.observe(el);
    });
  }

  /* ---------- Tabs (Produkt-Schaufenster & Produkt-Tabs) ---------- */
  function initTabs(root = document) {
    root.querySelectorAll('[data-hws-tabs]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const tabs = Array.from(wrap.querySelectorAll('[role="tab"]'));
      const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      const select = (index, focus) => {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = panels[i];
          if (!panel) return;
          if (active && panel.hidden) {
            panel.hidden = false;
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
            initFadeImages(panel);
          } else if (!active) {
            panel.hidden = true;
          }
        });
        if (focus) tabs[index].focus();
        // Pfeile auf den sichtbaren Slider umhängen
        const root = wrap.closest('[data-hws-slider-root]');
        if (root) bindActiveTrack(root);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          select((index + step + tabs.length) % tabs.length, true);
        });
      });
    });
  }

  /* ---------- Horizontale Slider: ein Pfeilpaar steuert den sichtbaren Slider ---------- */
  function bindActiveTrack(root) {
    const panel = Array.from(root.querySelectorAll('[data-hws-panel]')).find((p) => !p.hidden) || root;
    const track = panel.querySelector('.hws-track');
    const prev = root.querySelector('[data-hws-prev]');
    const next = root.querySelector('[data-hws-next]');
    if (!track || !prev || !next) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    const page = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
    prev.onclick = () => page(-1);
    next.onclick = () => page(1);
    if (!track.dataset.hwsBound) {
      track.dataset.hwsBound = '1';
      track.addEventListener('scroll', () => update(), { passive: true });
      window.addEventListener('resize', () => update(), { passive: true });
    }
    update();
  }

  function initSliders(root = document) {
    root.querySelectorAll('[data-hws-slider-root]').forEach((el) => bindActiveTrack(el));
  }

  /* ---------- Sticky „In den Warenkorb“ auf der Produktseite ---------- */
  function initStickyAtc() {
    const bar = document.querySelector('[data-hws-sticky-atc]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const info = document.querySelector('product-info[data-section]');
    const sectionId = info && info.dataset.section;
    const form = sectionId && document.querySelector(`#product-form-${sectionId}`);
    const submit = form && form.querySelector('[type="submit"]');
    const buyBox = document.querySelector(`#ProductInfo-${sectionId} .product-form__buttons`) || submit;
    if (!submit || !buyBox) return;

    const button = bar.querySelector('[data-hws-sticky-submit]');
    const price = bar.querySelector('[data-hws-sticky-price]');
    const sourcePrice = document.querySelector(`#price-${sectionId}`);

    const syncPrice = () => {
      if (!price || !sourcePrice) return;
      const current = sourcePrice.querySelector('.price__sale:not([hidden]) .price-item--sale, .price-item--regular');
      if (current) price.textContent = current.textContent.trim();
    };
    const syncState = () => {
      button.disabled = submit.disabled;
      button.textContent = submit.querySelector('span') ? submit.querySelector('span').textContent.trim() : submit.textContent.trim();
    };
    syncPrice();
    syncState();
    if (sourcePrice) new MutationObserver(syncPrice).observe(sourcePrice, { childList: true, subtree: true, characterData: true });
    new MutationObserver(syncState).observe(submit, { attributes: true, childList: true, subtree: true });

    button.addEventListener('click', () => submit.click());

    // Sichtbar, sobald der Kauf-Button oben aus dem Bild ist – aber nicht über dem Footer.
    // Bewusst per Scroll-Position statt IntersectionObserver: so klappt es auch bei
    // schnellen Wischgesten und Sprungmarken („Details ansehen“).
    const footer = document.querySelector('.hws-footer');
    let ticking = false;
    const update = () => {
      ticking = false;
      const passedBuyBox = buyBox.getBoundingClientRect().bottom < 0;
      const footerInView = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      const visible = passedBuyBox && !footerInView;
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
      document.documentElement.classList.toggle('hws-sticky-on', visible);
    };
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    bar.inert = true;
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  /* ---------- Versand-Countdown (Mo–Fr bis 14 Uhr, Sa bis 12 Uhr, Feiertage ausgenommen) ---------- */
  function berlinNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(new Date());
    const get = (type) => parseInt(parts.find((p) => p.type === type).value, 10);
    return { y: get('year'), m: get('month'), d: get('day'), h: get('hour') % 24, min: get('minute') };
  }

  function isoDate(date) {
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
  }

  function initDelivery(root = document) {
    root.querySelectorAll('[data-hws-delivery]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const cutoff = parseInt(box.dataset.cutoff || '14', 10);
      const cutoffSaturday = parseInt(box.dataset.cutoffSaturday || '12', 10);
      const cutoffFor = (date) => (date.getUTCDay() === 6 ? cutoffSaturday : cutoff);
      const minDays = parseInt(box.dataset.minDays || '1', 10);
      const maxDays = parseInt(box.dataset.maxDays || '2', 10);
      const holidays = new Set((box.dataset.holidays || '').split(/[\s,]+/).filter(Boolean));
      const title = box.querySelector('[data-hws-delivery-title]');
      const sub = box.querySelector('[data-hws-delivery-sub]');
      const fmt = new Intl.DateTimeFormat(dateLocale, { weekday: 'short', day: 'numeric', month: 'numeric', timeZone: 'UTC' });
      const fmtLong = new Intl.DateTimeFormat(dateLocale, { weekday: 'long', day: 'numeric', month: 'numeric', timeZone: 'UTC' });

      // Versand und DHL-Zustellung: Montag bis Samstag (Samstag abschaltbar in den Theme-Einstellungen)
      const saturday = box.dataset.saturday !== 'false';
      const isWorkday = (date) => {
        const day = date.getUTCDay();
        return day !== 0 && (day !== 6 || saturday) && !holidays.has(isoDate(date));
      };
      const addWorkdays = (date, count) => {
        const result = new Date(date);
        let added = 0;
        while (added < count) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (isWorkday(result)) added++;
        }
        return result;
      };

      const render = () => {
        const now = berlinNow();
        const today = new Date(Date.UTC(now.y, now.m - 1, now.d));
        let shipDay = new Date(today);
        const todayCutoff = cutoffFor(today);
        const shipsToday = isWorkday(today) && now.h < todayCutoff;
        if (!shipsToday) {
          do { shipDay.setUTCDate(shipDay.getUTCDate() + 1); } while (!isWorkday(shipDay));
        }
        const from = addWorkdays(shipDay, minDays);
        const to = addWorkdays(shipDay, maxDays);
        if (shipsToday) {
          const minutesLeft = todayCutoff * 60 - (now.h * 60 + now.min);
          const hours = Math.floor(minutesLeft / 60);
          const minutes = minutesLeft % 60;
          const left = hours > 0 ? `${hours} ${strings.hours} ${minutes} ${strings.minutes}` : `${minutes} ${strings.minutes}`;
          title.innerHTML = '<span class="hws-delivery__pulse" aria-hidden="true"></span>' + strings.orderWithin.replace('__TIME__', left);
        } else {
          title.innerHTML = strings.shipsOn.replace('__DATE__', fmtLong.format(shipDay));
        }
        sub.textContent = strings.estimate.replace('__FROM__', fmt.format(from)).replace('__TO__', fmt.format(to));
        box.hidden = false;
      };
      render();
      setInterval(render, 60 * 1000);
    });
  }


  /* ---------- Einblenden beim Scrollen ---------- */
  const revealObservers = {};
  function revealTarget(target) {
    if (target.hasAttribute('data-hws-reveal-group')) {
      target.querySelectorAll('[data-hws-reveal]').forEach((child) => child.classList.add('is-revealed'));
    }
    target.classList.add('is-revealed');
  }
  function observerFor(threshold) {
    if (revealObservers[threshold]) return revealObservers[threshold];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          revealTarget(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: threshold }
    );
    revealObservers[threshold] = observer;
    return observer;
  }
  function initReveal(root = document) {
    const designMode = window.Shopify && window.Shopify.designMode;
    const targets = [];
    root.querySelectorAll('[data-hws-reveal-group], [data-hws-reveal]').forEach((el) => {
      if (el.classList.contains('is-revealed')) return;
      // Elemente innerhalb einer Gruppe werden mit der Gruppe eingeblendet
      if (!el.hasAttribute('data-hws-reveal-group') && el.parentElement && el.parentElement.closest('[data-hws-reveal-group]')) return;
      targets.push(el);
    });
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      targets.forEach(revealTarget);
      return;
    }
    targets.forEach((el) => observerFor(parseFloat(el.dataset.hwsThreshold || '0.12')).observe(el));
  }

  /* ---------- Hero: leichte Parallaxe beim Scrollen ---------- */
  function initParallax() {
    if (reduceMotion) return;
    const hero = document.querySelector('.hws-hero');
    if (!hero || hero.dataset.parallax) return;
    hero.dataset.parallax = '1';
    const layers = [
      [hero.querySelector('.hws-hero__card--main'), -0.06],
      [hero.querySelector('.hws-hero__card--side'), -0.14],
      [hero.querySelector('.hws-hero__badge--a'), -0.2],
      [hero.querySelector('.hws-hero__badge--b'), -0.1],
    ].filter(([el]) => el);
    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const offset = Math.max(0, -rect.top);
      layers.forEach(([el, factor]) => { el.style.translate = `0 ${(offset * factor).toFixed(1)}px`; });
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Farbmodus: Hell / Dunkel / System ---------- */
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)');
  function currentPref() {
    try { return localStorage.getItem('hws-theme') || 'system'; } catch (e) { return 'system'; }
  }
  function applyTheme(pref, animate) {
    const dark = pref === 'dark' || (pref === 'system' && systemDark.matches);
    const apply = () => {
      document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
      document.documentElement.setAttribute('data-theme-pref', pref);
      document.querySelectorAll('[data-hws-theme-set]').forEach((btn) => {
        btn.setAttribute('aria-checked', String(btn.dataset.hwsThemeSet === pref));
      });
      document.querySelectorAll('[data-hws-theme-toggle]').forEach((btn) => {
        btn.setAttribute('aria-checked', String(dark));
        btn.setAttribute('aria-label', dark ? strings.toLight : strings.toDark);
      });
    };
    if (animate && document.startViewTransition && !reduceMotion) document.startViewTransition(apply);
    else apply();
  }
  function initTheme() {
    applyTheme(currentPref(), false);
    if (document.documentElement.dataset.hwsThemeReady) return;
    document.documentElement.dataset.hwsThemeReady = '1';
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-hws-theme-toggle]');
      const set = event.target.closest('[data-hws-theme-set]');
      if (!toggle && !set) return;
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      const pref = toggle ? (isDark ? 'light' : 'dark') : set.dataset.hwsThemeSet;
      try { localStorage.setItem('hws-theme', pref); } catch (e) {}
      applyTheme(pref, true);
    });
    systemDark.addEventListener('change', () => { if (currentPref() === 'system') applyTheme('system', true); });
  }

  /* ---------- Nach-oben-Button mit Fortschrittsring ---------- */
  function initToTop() {
    const btn = document.querySelector('[data-hws-totop]');
    if (!btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    let ticking = false;
    const update = () => {
      ticking = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0;
      btn.style.setProperty('--hws-progress', progress.toFixed(1));
      const visible = window.scrollY > window.innerHeight * 0.8;
      btn.classList.toggle('is-visible', visible);
      btn.tabIndex = visible ? 0 : -1;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    btn.addEventListener('click', (event) => {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      const viaKeyboard = event.detail === 0;
      if (!viaKeyboard) { btn.blur(); return; }
      const logo = document.querySelector('.header__heading-link');
      if (logo) setTimeout(() => logo.focus({ preventScroll: true }), reduceMotion ? 0 : 600);
    });
    update();
  }

  /* ---------- Ladebildschirm ausblenden ---------- */
  function endPreloader() {
    const root = document.documentElement;
    if (!root.classList.contains('hws-preload')) return;
    const loaded = new Promise((resolve) => {
      if (document.readyState === 'complete') resolve();
      else window.addEventListener('load', resolve, { once: true });
    });
    const fonts = document.fonts ? document.fonts.ready : Promise.resolve();
    const cap = new Promise((resolve) => setTimeout(resolve, 1800));
    Promise.race([Promise.all([loaded, fonts]), cap]).then(() => {
      const minVisible = 900; // Mindestzeit ab Seitenaufruf, damit nichts „blitzt“
      setTimeout(() => {
        root.classList.add('hws-preload-out');
        try { sessionStorage.setItem('hws-visited', '1'); } catch (e) {}
        setTimeout(() => root.classList.remove('hws-preload', 'hws-preload-out'), 600);
      }, Math.max(0, minVisible - performance.now()));
    });
  }

  /* ---------- Fortschrittsbalken beim Klick auf interne Links ---------- */
  function initNavProgress() {
    const bar = document.querySelector('.hws-nav-progress');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search)) return;
      bar.classList.remove('is-active');
      void bar.offsetWidth;
      bar.classList.add('is-active');
    });
    window.addEventListener('pageshow', () => bar.classList.remove('is-active'));
  }


  /* ---------- Bilder bei Ladefehler erneut anfordern (schwache Verbindung) ---------- */
  function withRetryParam(url, attempt) {
    if (!url) return url;
    return url.replace(/([?&])hws_retry=\d+/, '$1hws_retry=' + attempt).replace(/^([^?#\s]+)(\?[^#\s]*)?/, (m, base, query) => {
      if (/hws_retry=/.test(m)) return m;
      return base + (query ? query + '&' : '?') + 'hws_retry=' + attempt;
    });
  }
  function retryImage(img) {
    if (img.dataset.hwsRetryPending) return; // schon ein neuer Versuch geplant
    const attempt = parseInt(img.dataset.hwsRetry || '0', 10) + 1;
    if (attempt > 4 || !img.getAttribute('src')) return;
    img.dataset.hwsRetry = String(attempt);
    img.dataset.hwsRetryPending = '1';
    const delay = navigator.onLine === false ? 0 : 800 * attempt;
    const run = () => {
      delete img.dataset.hwsRetryPending;
      const srcset = img.getAttribute('srcset');
      if (srcset) {
        img.setAttribute('srcset', srcset.split(',').map((part) => {
          const [url, ...rest] = part.trim().split(/\s+/);
          return [withRetryParam(url, attempt), ...rest].join(' ');
        }).join(', '));
      }
      img.setAttribute('src', withRetryParam(img.getAttribute('src'), attempt));
    };
    if (navigator.onLine === false) window.addEventListener('online', run, { once: true });
    else setTimeout(run, delay);
  }
  function initImageRetry() {
    if (document.documentElement.dataset.hwsImgRetry) return;
    document.documentElement.dataset.hwsImgRetry = '1';
    document.addEventListener('error', (event) => {
      if (event.target && event.target.tagName === 'IMG') retryImage(event.target);
    }, true);
    // Bilder, die schon vor dem Laden dieses Skripts fehlgeschlagen sind
    document.querySelectorAll('img').forEach((img) => {
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) retryImage(img);
    });
  }


  /* ---------- Automatisch weiterblättern (z. B. Kundenstimmen) ---------- */
  function initAutoplay(root = document) {
    if (reduceMotion) return;
    root.querySelectorAll('[data-hws-autoplay]').forEach((wrap) => {
      if (wrap.dataset.autoplayReady) return;
      wrap.dataset.autoplayReady = '1';
      const track = wrap.querySelector('.hws-track');
      if (!track) return;
      const delay = parseInt(wrap.dataset.hwsAutoplay, 10) || 5000;
      let paused = false;
      let inView = false;
      const pause = () => (paused = true);
      const resume = () => (paused = false);
      wrap.addEventListener('mouseenter', pause);
      wrap.addEventListener('mouseleave', resume);
      wrap.addEventListener('focusin', pause);
      wrap.addEventListener('focusout', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', () => setTimeout(resume, 4000), { passive: true });
      new IntersectionObserver((entries) => { inView = entries[0].isIntersecting; }, { threshold: 0.4 }).observe(track);
      setInterval(() => {
        if (paused || !inView || document.hidden) return;
        const first = track.children[0];
        const second = track.children[1];
        if (!first) return;
        const step = second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
      }, delay);
    });
  }


  /* ---------- Sprachumschalter: Daumen gleitet erst, dann Seitenwechsel ---------- */
  function initLanguageToggle() {
    if (document.documentElement.dataset.hwsLangReady) return;
    document.documentElement.dataset.hwsLangReady = '1';
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.hws-lang__btn');
      if (!btn) return;
      event.preventDefault();
      if (btn.getAttribute('aria-current') === 'true') return;
      const pill = btn.closest('[data-hws-lang]');
      const buttons = Array.from(pill.querySelectorAll('.hws-lang__btn'));
      pill.style.setProperty('--hws-lang-i', buttons.indexOf(btn));
      buttons.forEach((b) => b.setAttribute('aria-current', String(b === btn)));
      setTimeout(() => btn.form.requestSubmit(btn), reduceMotion ? 0 : 260);
    });
  }


  /* ---------- Anmelde-Dialog ---------- */
  function initAuthDialog() {
    const dialog = document.querySelector('[data-hws-auth]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = '1';
    const close = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (reduceMotion) return dialog.close();
      dialog.classList.add('is-closing');
      setTimeout(() => { dialog.classList.remove('is-closing'); dialog.close(); }, 140);
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-hws-auth-open]');
      if (!trigger) return;
      event.preventDefault();
      // nach der Anmeldung zurück auf genau diese Seite
      const back = location.pathname + location.search;
      dialog.querySelectorAll('[data-hws-auth-login]').forEach((a) => {
        a.href = dialog.dataset.loginBase + '&return_to=' + encodeURIComponent(back);
      });
      dialog.showModal();
      document.documentElement.classList.add('hws-dialog-open');
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('hws-dialog-open'));
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    dialog.querySelectorAll('[data-hws-auth-close]').forEach((btn) => btn.addEventListener('click', close));
    // Klick auf den abgedunkelten Hintergrund schließt (nicht auf dem Handy-Vollbild)
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog || window.matchMedia('(max-width: 639px)').matches) return;
      const r = dialog.getBoundingClientRect();
      const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) close();
    });
  }

  /* ---------- Konto-Menü (angemeldet): öffnen/schließen wie ein shadcn-Dropdown ---------- */
  function initAccountMenu() {
    const wrap = document.querySelector('[data-hws-umenu]');
    if (!wrap || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    const toggle = wrap.querySelector('[data-hws-umenu-toggle]');
    const panel = wrap.querySelector('.hws-umenu__panel');
    const items = () => Array.from(panel.querySelectorAll('[role="menuitem"]'));
    const open = (focusFirst) => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (focusFirst) items()[0]?.focus();
    };
    const close = (focusToggle) => {
      if (panel.hidden) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (focusToggle) toggle.focus();
    };
    toggle.addEventListener('click', () => (panel.hidden ? open(false) : close(false)));
    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') { event.preventDefault(); open(true); }
    });
    panel.addEventListener('keydown', (event) => {
      const list = items();
      const i = list.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); list[(i + 1) % list.length].focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); list[(i - 1 + list.length) % list.length].focus(); }
      if (event.key === 'Escape') close(true);
      if (event.key === 'Tab') close(false);
    });
    document.addEventListener('click', (event) => { if (!wrap.contains(event.target)) close(false); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(true); });
    window.addEventListener('scroll', () => close(false), { passive: true });
  }

  /* ---------- Kopfzeile: „Kategorien" öffnet mit der Maus beim Darüberfahren (Klick/Tastatur über Dawns header-menu) ---------- */
  function initMegaCategories() {
    const item = document.querySelector('.hws-megacat');
    if (!item || item.dataset.ready || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    item.dataset.ready = '1';
    const details = item.querySelector('details');
    const summary = details.querySelector('summary');
    let timer = 0;
    let byHover = false;
    const setOpen = (open) => {
      details.open = open;
      summary.setAttribute('aria-expanded', String(open));
    };
    item.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      if (!details.open) { byHover = true; setOpen(true); }
    });
    item.addEventListener('mouseleave', () => {
      clearTimeout(timer);
      timer = setTimeout(() => { byHover = false; setOpen(false); }, 220);
    });
    // Klick direkt nach dem Öffnen per Hover soll das Menü nicht gleich wieder schließen
    summary.addEventListener('click', (event) => {
      if (byHover) { event.preventDefault(); byHover = false; }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) { setOpen(false); summary.focus(); }
    });
  }

  /* ---------- Laufende Reihe (Startseite „Finde dein Ersatzteil") ----------
     Karten liegen auf einem Bogen (Halbkreis) und drehen sich wie ein Rad: läuft langsam von allein,
     mit Finger oder Maus ziehen und anschubsen (Schwung läuft aus), Tippen hält an.
     Position, Bogen und Schwung werden in einem Bild (requestAnimationFrame) berechnet – daher ruckelfrei
     und die Karten bleiben auch bei schnellem Drehen auf der Bahn. Ohne JavaScript: normale wischbare Reihe. */
  function initDrift(root = document) {
    root.querySelectorAll('[data-hws-drift]').forEach((box) => {
      if (box.dataset.ready) return;
      const track = box.querySelector('.hws-drift__track');
      const originals = track ? Array.from(track.children) : [];
      if (originals.length < 2) return;
      box.dataset.ready = '1';
      box.classList.add('is-js');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const phone = () => window.matchMedia('(max-width: 749px)').matches;
      const speed = Number(box.dataset.speed || 26);
      const gpu = window.matchMedia('(pointer: coarse)').matches;
      // Desktop: „Karte für Karte" – das Rad steht gestochen scharf und dreht sich kurz um eine Karte weiter.
      // Langsames Gleiten um Bruchteile von Pixeln lässt Fotos auf normalen Bildschirmen flimmern (Farb-„Wellen").
      // Nach Chromes Empfehlung bekommen die Karten nur während der Bewegung eine Grafikkarten-Ebene (will-change)
      // und werden im Stand neu und scharf gezeichnet. Handy/Touch und Einstellung „Gleitend": ruhiges Gleiten.
      const mode = gpu || box.dataset.motion === 'glide' ? 'glide' : 'step';
      const dpr = window.devicePixelRatio || 1;
      const crisp = (v) => Math.round(v * dpr) / dpr;
      const PAUSE = 2400;
      const MOVE = 850;
      const SETTLE = 450;
      const easeInOut = (k) => (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);
      const easeOut = (k) => 1 - Math.pow(1 - k, 3);
      let anim = null; // { from, to, t0, dur, ease }
      let moving = mode === 'glide';
      let nextStepAt = performance.now() + PAUSE;
      let wheelTimer = 0;
      const items = originals.slice();
      let itemW = 0;
      let step = 0;
      let belt = 0;
      let width = 0;
      let radius = 0;
      let pos = 0; // Strecke des Rads in px
      let vel = 0; // Schwung in px/ms
      let last = 0;
      let holdUntil = 0;
      let hover = false;
      let inView = true;
      let dirty = true;

      const layout = () => {
        const cs = getComputedStyle(track);
        const gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 16;
        itemW = originals[0].offsetWidth;
        step = itemW + gap;
        width = box.clientWidth;
        // Genug Kopien, damit der Ring nie Lücken hat (Kopien für Screenreader/Tastatur unsichtbar)
        while (items.length * step < width + step * 3) {
          originals.forEach((li) => {
            const copy = li.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-shopify-editor-block');
            copy.querySelectorAll('a').forEach((a) => { a.tabIndex = -1; });
            track.appendChild(copy);
            items.push(copy);
          });
        }
        belt = items.length * step;
        radius = Math.max(width * (phone() ? 1.35 : 2), 440);
        const edge = Math.asin(Math.min(0.9, width / 2 / radius));
        box.style.setProperty('--hws-arc-depth', `${Math.round(radius * (1 - Math.cos(edge)))}px`);
        track.style.height = `${originals[0].offsetHeight}px`;
        dirty = true;
      };
      const render = () => {
        const half = width / 2;
        items.forEach((li, i) => {
          let x = (((i * step - pos) % belt) + belt) % belt;
          if (x > belt / 2) x -= belt; // Abstand zur Mitte
          if (Math.abs(x) > half + step) { li.style.visibility = 'hidden'; return; }
          li.style.visibility = '';
          const a = Math.asin(Math.max(-0.9, Math.min(0.9, x / radius)));
          const y = radius * (1 - Math.cos(a));
          const tx = half + x - itemW / 2;
          const rot = ((a * 180) / Math.PI).toFixed(3);
          // in Bewegung: Grafikkarten-Ebene (flüssig); im Stand: ganze Pixel, scharf gezeichnet
          li.style.transform = moving
            ? `translate3d(${tx.toFixed(2)}px, ${y.toFixed(2)}px, 0) rotate(${rot}deg)`
            : `translate(${crisp(tx)}px, ${crisp(y)}px) rotate(${rot}deg)`;
        });
      };

      const setMoving = (on) => {
        if (mode === 'glide' || on === moving) return;
        moving = on;
        box.classList.toggle('is-moving', on);
        dirty = true;
      };
      // auf die nächste Karte einrasten (nur „Karte für Karte")
      const settle = (target) => {
        if (mode !== 'step') return;
        const to = target === undefined ? Math.round(pos / step) * step : target;
        if (Math.abs(to - pos) < 0.5) { pos = to; anim = null; setMoving(false); nextStepAt = performance.now() + PAUSE; return; }
        anim = { from: pos, to, t0: performance.now(), dur: SETTLE, ease: easeOut };
        setMoving(true);
      };

      // Ziehen mit Finger oder Maus; senkrechtes Wischen bleibt Seiten-Scrollen (touch-action: pan-y)
      let pid = null;
      let startX = 0;
      let startY = 0;
      let startPos = 0;
      let intent = null;
      let samples = [];
      let blockClick = false;
      box.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        pid = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        anim = null; // Tippen hält das Rad an
        startPos = pos;
        intent = null;
        blockClick = false;
        vel = 0;
        samples = [[performance.now(), e.clientX]];
      });
      box.addEventListener('pointermove', (e) => {
        if (e.pointerId !== pid) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (!intent) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          intent = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (intent === 'x') {
            blockClick = true;
            setMoving(true);
            box.classList.add('is-dragging');
            // Maus/Stift: ab jetzt kommen alle Zeiger-Ereignisse hierher – auch das Loslassen außerhalb des Kastens.
            // Finger hält der Browser ohnehin am berührten Element fest (die Ereignisse kommen trotzdem hier an);
            // umhängen würde Safari als „Finger verloren" melden und das Drehen nach wenigen Pixeln beenden.
            if (e.pointerType !== 'touch') {
              try { box.setPointerCapture(pid); } catch (err) { /* Zeiger schon weg */ }
            }
          }
        }
        if (intent !== 'x') return;
        pos = startPos - dx;
        dirty = true;
        const now = performance.now();
        samples.push([now, e.clientX]);
        while (samples.length > 2 && now - samples[0][0] > 90) samples.shift();
      });
      const release = (e) => {
        if (e.pointerId !== pid) return;
        pid = null;
        if (intent === 'x') {
          const [t0, x0] = samples[0];
          const [t1, x1] = samples[samples.length - 1];
          const v = t1 > t0 && performance.now() - t1 < 80 ? -(x1 - x0) / (t1 - t0) : 0;
          vel = Math.max(-4, Math.min(4, v));
          if (Math.abs(vel) < 0.05) vel = 0;
        }
        holdUntil = performance.now() + 1500;
        intent = null;
        box.classList.remove('is-dragging');
        if (!vel) settle(); // ohne Schwung gleich auf die nächste Karte einrasten
      };
      box.addEventListener('pointerup', release);
      box.addEventListener('pointercancel', release);
      // nur der Verlust der eigenen Erfassung zählt (nicht die eines Bildes oder Links in der Karte)
      box.addEventListener('lostpointercapture', (e) => { if (e.target === box) release(e); });
      // Sicherheitsnetz: Loslassen irgendwo im Fenster (oder Fenster verlassen) beendet das Festhalten immer
      window.addEventListener('pointerup', release);
      window.addEventListener('blur', () => { if (pid !== null) release({ pointerId: pid }); });
      box.addEventListener('click', (e) => { if (blockClick) { e.preventDefault(); e.stopPropagation(); blockClick = false; } }, true);
      box.addEventListener('dragstart', (e) => e.preventDefault());
      // Trackpad: seitlich wischen dreht das Rad
      box.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        anim = null;
        setMoving(true);
        pos += e.deltaX;
        vel = 0;
        holdUntil = performance.now() + 1500;
        dirty = true;
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(() => settle(), 160);
      }, { passive: false });
      box.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
      box.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hover = false; holdUntil = performance.now() + 400; } });
      // Tastatur (Tab): fokussierte Karte in die Mitte holen – nicht beim Anklicken mit der Maus (sonst springt das Rad)
      box.addEventListener('focusin', (e) => {
        const li = e.target.closest('.hws-drift__item');
        if (!li || !e.target.matches(':focus-visible')) return;
        hover = true;
        const target = items.indexOf(li) * step;
        vel = 0;
        if (mode === 'step') settle(target + Math.round((pos - target) / belt) * belt);
        else { pos = target + Math.round((pos - target) / belt) * belt; dirty = true; }
      });
      box.addEventListener('focusout', (e) => { if (e.target.matches(':focus-visible')) hover = false; });
      // Der Browser darf den Kasten nie selbst verschieben (z. B. beim Fokussieren eines Links)
      box.addEventListener('scroll', () => { if (box.scrollLeft || box.scrollTop) { box.scrollLeft = 0; box.scrollTop = 0; } }, { passive: true });

      const tick = (t) => {
        requestAnimationFrame(tick);
        const dt = last ? Math.min(t - last, 50) : 16;
        last = t;
        if (!inView || document.hidden || !belt) return;
        if (pid !== null) {
          // Finger/Maus führt
        } else if (vel) {
          setMoving(true);
          pos += vel * dt;
          vel *= Math.pow(0.95, dt / 16); // Schwung läuft aus
          if (Math.abs(vel) < (mode === 'step' ? 0.12 : 0.02)) {
            vel = 0;
            holdUntil = t + 1200;
            settle();
          }
          dirty = true;
        } else if (anim) {
          const k = Math.min(1, (t - anim.t0) / anim.dur);
          pos = anim.from + (anim.to - anim.from) * anim.ease(k);
          dirty = true;
          if (k >= 1) {
            pos = anim.to;
            anim = null;
            setMoving(false);
            nextStepAt = t + PAUSE;
          }
        } else if (mode === 'step') {
          if (!reduce && speed && !hover && t >= nextStepAt && t >= holdUntil) {
            anim = { from: pos, to: Math.round(pos / step) * step + step, t0: t, dur: MOVE, ease: easeInOut };
            setMoving(true);
          }
        } else if (!reduce && speed && !hover && t > holdUntil) {
          pos += (speed * (phone() ? 0.8 : 1) * dt) / 1000;
          dirty = true;
        }
        if (!anim && !vel && pid === null && (pos > belt * 1000 || pos < -belt * 1000)) pos %= belt;
        if (dirty) { render(); dirty = false; }
      };
      layout();
      window.addEventListener('resize', layout, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { inView = entries[0].isIntersecting; }).observe(box);
      }
      // für Tests: aktuelle Position und Schwung
      box.hwsDrift = { get pos() { return pos; }, get vel() { return vel; }, get mode() { return mode; }, get step() { return step; }, get moving() { return moving; } };
      requestAnimationFrame(tick);
    });
  }

  /* ---------- Reparatur buchen (Produktvorlage „reparatur", snippets/hws-repair-booking.liquid) ----------
     Dauer je Variante (Teil auf Lager oder wird bestellt), Pflicht-Häkchen vor dem Hinzufügen, Express als zweite
     Position im selben Warenkorb-Aufruf (items[0] Reparatur, items[1] Express). */
  function initRepairBooking(root = document) {
    root.querySelectorAll('[data-hws-repair]').forEach((box) => {
      if (box.dataset.ready) return;
      const form = document.getElementById(box.dataset.form);
      if (!form) return;
      box.dataset.ready = '1';
      let stock = {};
      try { stock = JSON.parse(box.querySelector('[data-hws-repair-stock]').textContent); } catch (e) { /* ohne Angabe */ }
      const timeEl = box.querySelector('[data-hws-repair-time]');
      const express = box.querySelector('[data-hws-repair-express]');
      const error = box.querySelector('[data-hws-repair-error]');
      const required = Array.from(box.querySelectorAll('[data-hws-repair-required]'));
      if (error) error.dataset.text = error.textContent;
      const currentId = () => { const i = form.querySelector('input[name="id"]'); return i ? i.value : ''; };
      const showTime = (id) => {
        const q = stock[String(id)];
        const inStock = q === undefined || q > 0;
        timeEl.querySelector('[data-hws-repair-time-main]').textContent = inStock ? timeEl.dataset.in : timeEl.dataset.order;
        timeEl.querySelector('[data-hws-repair-time-ship]').textContent = (inStock ? timeEl.dataset.inShip : timeEl.dataset.orderShip) || '';
        timeEl.classList.toggle('is-order', !inStock);
      };
      showTime(currentId());
      // Dawn setzt die Button-Beschriftung beim Variantenwechsel aus window.variantStrings
      if (window.variantStrings && box.dataset.button) window.variantStrings.addToCart = box.dataset.button;
      // Pause: gesperrter Knopf heißt „Gerade keine Annahme" statt „Ausverkauft"
      if (window.variantStrings && box.dataset.paused) window.variantStrings.soldOut = box.dataset.paused;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const v = event && event.data && event.data.variant;
          if (v) showTime(v.id);
        });
      }
      required.forEach((input) => input.addEventListener('change', () => {
        input.closest('label').classList.toggle('is-missing', !input.checked);
        if (required.every((i) => i.checked)) error.hidden = true;
      }));
      // Pflicht-Häkchen prüfen, bevor Dawns Produktformular abschickt (Formular hat novalidate)
      document.addEventListener('submit', (event) => {
        if (event.target !== form) return;
        if (box.dataset.paused) {
          event.preventDefault();
          event.stopPropagation();
          const note = box.querySelector('.hws-rpause');
          if (note) note.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        const model = document.querySelector('[data-hws-msum]');
        if (model && !model.dataset.chosen) {
          event.preventDefault();
          event.stopPropagation();
          model.dataset.state = 'open';
          model.classList.add('is-missing');
          error.textContent = model.dataset.missing;
          error.hidden = false;
          model.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        if (model) model.classList.remove('is-missing');
        error.textContent = error.dataset.text || error.textContent;
        const missing = required.filter((i) => !i.checked);
        if (!missing.length) return;
        event.preventDefault();
        event.stopPropagation();
        missing.forEach((i) => i.closest('label').classList.add('is-missing'));
        error.hidden = false;
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
        missing[0].focus({ preventScroll: true });
      }, true);
      // Express: Reparatur und Express in einem Aufruf in den Warenkorb
      form.addEventListener('formdata', (event) => {
        if (!express || !express.checked || !box.dataset.expressId) return;
        const fd = event.formData;
        const id = fd.get('id');
        if (!id) return;
        const quantity = fd.get('quantity') || '1';
        const props = [];
        Array.from(fd.keys()).forEach((key) => {
          const m = /^properties\[(.*)\]$/.exec(key);
          if (m) props.push([m[1], fd.get(key)]);
        });
        fd.delete('id');
        fd.delete('quantity');
        props.forEach(([key]) => fd.delete(`properties[${key}]`));
        fd.append('items[0][id]', id);
        fd.append('items[0][quantity]', quantity);
        props.forEach(([key, value]) => fd.append(`items[0][properties][${key}]`, value));
        fd.append('items[0][properties][Express]', '✓');
        fd.append('items[1][id]', box.dataset.expressId);
        fd.append('items[1][quantity]', '1');
        const variantTitle = (form.closest('product-info') || document).querySelector('variant-selects [data-selected-variant]');
        let label = box.dataset.productTitle;
        try { if (variantTitle) label += ` – ${JSON.parse(variantTitle.textContent).title}`; } catch (e) { /* nur Produktname */ }
        fd.append(`items[1][properties][${box.dataset.expressFor || 'Für'}]`, label);
      });
    });
  }

  /* ---------- Reparatur-Produktseite: kompakte Modellwahl (snippets/hws-repair-model.liquid) ----------
     Zustand am Kasten: data-state open/closed, data-num = gezeigte Nummer, data-chosen = Modell bewusst gewählt. */
  function initRepairModel(root = document) {
    root.querySelectorAll('[data-hws-msum]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const info = box.closest('.product__info-container') || document;
      const numOf = (v) => ((/(\d+)/.exec(v || '') || [])[1] || '');
      const current = () => {
        const fs = info.querySelector('variant-selects fieldset');
        const input = fs && fs.querySelector('input:checked');
        return input ? input.value : '';
      };
      let chosen = new URLSearchParams(location.search).has('variant');
      let editing = false;
      const render = () => {
        const value = current();
        box.querySelector('[data-hws-msum-value]').textContent = value;
        box.dataset.chosen = chosen ? '1' : '';
        box.dataset.state = chosen && !editing ? 'closed' : 'open';
        if (box.dataset.single) return;
        if (box.dataset.state === 'closed') box.dataset.num = numOf(value);
        box.querySelectorAll('[data-hws-msum-num]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.hwsMsumNum === box.dataset.num)));
      };
      box.addEventListener('click', (event) => {
        const num = event.target.closest('[data-hws-msum-num]');
        if (num) { box.dataset.num = num.dataset.hwsMsumNum; editing = true; render(); return; }
        if (event.target.closest('[data-hws-msum-change]')) {
          editing = true;
          box.dataset.num = box.dataset.single ? box.dataset.num : numOf(current());
          render();
        }
      });
      // Modell angetippt (auch das schon markierte) → gewählt, zuklappen. Farbe wählen zählt nicht als Modellwahl.
      info.addEventListener('click', (event) => {
        const label = event.target.closest('variant-selects label');
        const fs = label && label.closest('fieldset');
        if (!fs || fs !== info.querySelector('variant-selects fieldset')) return;
        chosen = true;
        editing = false;
        setTimeout(render, 0);
      });
      // Modell per Code geändert („Mein Gerät" wählt vor) → ebenfalls gewählt
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          requestAnimationFrame(() => {
            const modelChanged = current() !== box.querySelector('[data-hws-msum-value]').textContent;
            if (modelChanged) { chosen = true; editing = false; }
            render();
          });
        });
      }
      render();
    });
  }

  /* ---------- Reparatur-Seite: Preisrechner (sections/hws-repair-page.liquid) ----------
     Daten = alle Varianten der Reparatur-Produkte (Art, Modell, Farbe, Preis in Cent, Bestand, Link).
     Nummer wählen → Modell wählen → je Reparatur eine Karte (Preis, „ab" bei mehreren Farben, Dauer je nach Bestand). */
  function initRepairFinder(root = document) {
    root.querySelectorAll('[data-hws-repair-finder]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      let rows = [];
      try { rows = JSON.parse(box.querySelector('[data-hws-rf-data]').textContent); } catch (e) { return; }
      const d = box.dataset;
      const seriesEl = box.querySelector('[data-hws-rf-series]');
      const modelsWrap = box.querySelector('[data-hws-rf-models]');
      const modelList = box.querySelector('[data-hws-rf-model-list]');
      const results = box.querySelector('[data-hws-rf-results]');
      const money = (cents) => {
        const amount = (cents / 100).toFixed(2);
        const fmt = d.money || '{{amount_with_comma_separator}} €';
        return fmt
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount\s*\}\}/, amount);
      };
      const esc = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      // „iPhone 11 Pro Max (OLED)" → Modell „iPhone 11 Pro Max", Zusatz „OLED"
      rows.forEach((r) => {
        const m = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(r.m || '');
        r.base = (m ? m[1] : r.m || '').trim();
        r.extra = m ? m[2] : '';
        const n = /(\d+)/.exec(r.base);
        r.num = n ? n[1] : r.base;
      });
      const rank = (name) => {
        const t = name.toLowerCase().replace('iphone', '').trim();
        const num = parseInt(t, 10) || 0;
        const rest = t.replace(/^\d+\s*/, '');
        const order = { '': 0, e: 1, mini: 1, plus: 2, pro: 3, 'pro max': 4 };
        return num * 10 + (order[rest] !== undefined ? order[rest] : 5);
      };
      const models = [...new Set(rows.map((r) => r.base))].sort((a, b) => rank(a) - rank(b));
      const nums = [...new Set(models.map((m) => (/(\d+)/.exec(m) || [])[1]))].filter(Boolean).sort((a, b) => b - a);
      let num = null;
      let model = null;
      const chip = (label, attrs) => `<button type="button" class="hws-devchip" ${attrs}>${esc(label)}</button>`;
      const renderSeries = () => {
        seriesEl.innerHTML = nums.map((n) => chip(n, `data-num="${n}" aria-pressed="${n === num}"`)).join('');
      };
      const renderModels = () => {
        modelsWrap.hidden = !num;
        if (!num) return;
        modelList.innerHTML = models.filter((m) => (/(\d+)/.exec(m) || [])[1] === num)
          .map((m) => chip(m.replace(/^iPhone\s*/, ''), `data-model="${esc(m)}" aria-pressed="${m === model}"`)).join('');
      };
      // Preis mit Reparatur-Rabatt (automatischer Rabatt, auf ganze Cent abgerundet wie im Warenkorb)
      const pct = Number(d.pct || 0);
      const priceHtml = (cents, from) => {
        const prefix = from ? `${esc(d.from)} ` : '';
        if (!pct) return `<span class="hws-rp__result-price">${prefix}${esc(money(cents))}</span>`;
        const final = cents - Math.floor((cents * pct) / 100);
        return `<span class="hws-rp__result-prices">
          <span class="hws-rp__result-price"><span class="hws-dbadge hws-dbadge--inline">${esc(d.badge)}</span>${prefix}${esc(money(final))}</span>
          <s class="hws-rp__result-was"><span class="visually-hidden">${esc(d.regular)} </span>${esc(money(cents))}</s>
        </span>`;
      };
      const card = (kind, list) => {
        const prices = list.map((r) => r.p);
        const min = Math.min(...prices);
        const inStock = list.filter((r) => r.q > 0);
        const target = (inStock[0] || list[0]);
        const colors = new Set(list.map((r) => r.c).filter(Boolean));
        const extra = list[0].extra ? ` (${esc(list[0].extra)})` : '';
        const icon = { akku: 'battery', display: 'display', backcover: 'backcover' }[kind];
        const svg = box.querySelector(`[data-hws-rf-icon="${icon}"]`);
        return `<li class="hws-rp__result">
          <span class="hws-rp__result-icon">${svg ? svg.innerHTML : ''}</span>
          <div class="hws-rp__result-body">
            <strong>${esc(d[kind] || kind)}${extra}</strong>
            <span class="hws-rp__result-time ${inStock.length ? '' : 'is-order'}">${esc(inStock.length ? d.in : d.order)}</span>
            ${colors.size > 1 ? `<small>${esc(d.colors.replace('__COUNT__', colors.size))}</small>` : ''}
          </div>
          <div class="hws-rp__result-buy">
            ${priceHtml(min, new Set(prices).size > 1)}
            ${d.paused ? `<span class="hws-btn hws-btn--primary is-disabled" aria-disabled="true">${esc(d.paused)}</span>` : `<a class="hws-btn hws-btn--primary" href="${esc(target.u)}">${esc(d.book)}</a>`}
          </div>
        </li>`;
      };
      const renderResults = () => {
        results.hidden = !model;
        if (!model) return;
        const mine = rows.filter((r) => r.base === model);
        const html = [];
        ['akku', 'display', 'backcover'].forEach((kind) => {
          const list = mine.filter((r) => r.k === kind);
          if (!list.length) return;
          // Display-Varianten mit Zusatz (TFT/OLED) als eigene Karten
          const groups = {};
          list.forEach((r) => { (groups[r.extra] = groups[r.extra] || []).push(r); });
          Object.keys(groups).forEach((g) => html.push(card(kind, groups[g])));
        });
        results.innerHTML = html.join('');
      };
      const pick = (m, scroll) => {
        model = m;
        num = m ? (/(\d+)/.exec(m) || [])[1] : num;
        renderSeries();
        renderModels();
        renderResults();
        if (scroll && model) results.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      };
      box.addEventListener('click', (event) => {
        const n = event.target.closest('[data-num]');
        if (n) { num = n.dataset.num; if (model && (/(\d+)/.exec(model) || [])[1] !== num) model = null; renderSeries(); renderModels(); renderResults(); return; }
        const m = event.target.closest('[data-model]');
        if (m) pick(m.dataset.model, true);
      });
      // Vorauswahl: ?model=… im Link, sonst das unter „Mein Gerät" gespeicherte iPhone
      let pre = new URLSearchParams(location.search).get('model');
      if (!pre && window.hwsDevice && typeof window.hwsDevice.get === 'function') {
        const st = window.hwsDevice.get();
        if (st && st.iphone) pre = st.iphone.label;
      }
      const norm = (t) => String(t || '').toLowerCase().replace(/iphone/g, '').replace(/\s+/g, '');
      const found = pre ? models.find((m) => norm(m) === norm(pre)) : null;
      renderSeries();
      if (found) pick(found, false);
    });
  }

  /* ---------- Zurück-Knopf (Tablet/Desktop): im Verlauf zurück, sonst zur übergeordneten Seite ---------- */
  function initBackbar() {
    if (document.documentElement.dataset.hwsBackReady) return;
    document.documentElement.dataset.hwsBackReady = '1';
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-hws-back]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      let sameOrigin = false;
      try { sameOrigin = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) { /* ungültiger Referrer */ }
      if (sameOrigin && history.length > 1) { event.preventDefault(); history.back(); }
    });
  }

  /* ---------- Produktsicherheit: Ausführung, Artikelnummer und EAN folgen der gewählten Variante ---------- */
  function initGpsrVariant() {
    if (document.documentElement.dataset.hwsGpsr || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    document.documentElement.dataset.hwsGpsr = '1';
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const v = event && event.data && event.data.variant;
      if (!v) return;
      const sku = String(v.sku || '').replace('LAGERBESTAND - ', '').replace('SEIDOS', 'HWS');
      document.querySelectorAll('[data-hws-gpsr-variant]').forEach((el) => { el.textContent = v.title; });
      document.querySelectorAll('[data-hws-gpsr-sku]').forEach((el) => { el.textContent = sku; });
      document.querySelectorAll('[data-hws-gpsr-ean]').forEach((el) => { el.textContent = v.barcode || '–'; });
    });
  }

  /* ---------- Auswahlliste im HWS24-Stil statt nativer Dropdowns (Windows zeigt sonst eine alte Liste am Bildschirmrand) ----------
     Das echte <select> bleibt unsichtbar die Quelle (Wert + change-Event); die Liste klappt direkt unter dem Feld auf. */
  window.hwsEnhanceSelect = function hwsEnhanceSelect(select, opts = {}) {
    if (!select || select.dataset.hwsEnhanced) return;
    select.dataset.hwsEnhanced = '1';
    const uid = select.id || `hws-sel-${Math.random().toString(36).slice(2, 8)}`;
    const field = select.closest('.hws-field') || select.parentElement;
    const label = field.querySelector(`label[for="${select.id}"]`);
    const wrap = document.createElement('div');
    wrap.className = 'hws-select';
    wrap.innerHTML = `<button type="button" class="hws-select__btn hws-field__input" id="${uid}-btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="${uid}-list">
        <span class="hws-select__value"></span>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
      </button>
      <div class="hws-select__panel" hidden>
        <div class="hws-select__search" hidden><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><input type="text" autocomplete="off" spellcheck="false" placeholder="${opts.search || 'Suchen …'}" aria-label="${opts.search || 'Suchen'}"></div>
        <ul class="hws-select__list" id="${uid}-list" role="listbox" tabindex="-1"></ul>
        <p class="hws-select__empty" hidden>${opts.empty || 'Keine Treffer'}</p>
      </div>`;
    select.after(wrap);
    select.classList.add('hws-select__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    const btn = wrap.querySelector('.hws-select__btn');
    const valueEl = wrap.querySelector('.hws-select__value');
    const panel = wrap.querySelector('.hws-select__panel');
    const searchBox = wrap.querySelector('.hws-select__search');
    const search = searchBox.querySelector('input');
    const list = wrap.querySelector('.hws-select__list');
    const empty = wrap.querySelector('.hws-select__empty');
    if (label) { label.htmlFor = btn.id; label.id = label.id || `${uid}-label`; list.setAttribute('aria-labelledby', label.id); }
    const coarse = window.matchMedia('(pointer: coarse)');
    let active = -1;

    const items = () => [...list.querySelectorAll('[role="option"]:not([hidden])')];
    const render = () => {
      const opts2 = [...select.options];
      const placeholder = opts2.find((o) => o.value === '');
      const chosen = select.selectedOptions[0];
      valueEl.textContent = chosen ? chosen.textContent.trim() : '';
      valueEl.classList.toggle('is-placeholder', !chosen || chosen.value === '');
      btn.disabled = select.disabled;
      wrap.classList.toggle('is-disabled', select.disabled);
      list.innerHTML = opts2.filter((o) => o.value !== '').map((o, i) => `<li role="option" id="${uid}-o${i}" data-value="${o.value.replace(/"/g, '&quot;')}" aria-selected="${o.selected && o.value !== '' ? 'true' : 'false'}"><span>${o.textContent.trim().replace(/</g, '&lt;')}</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></li>`).join('');
      searchBox.hidden = opts2.length < 10;
      if (placeholder && !chosen) valueEl.textContent = placeholder.textContent.trim();
    };
    const setActive = (i) => {
      const its = items();
      its.forEach((li) => li.classList.remove('is-active'));
      active = Math.max(0, Math.min(i, its.length - 1));
      const li = its[active];
      if (li) { li.classList.add('is-active'); li.scrollIntoView({ block: 'nearest' }); list.setAttribute('aria-activedescendant', li.id); }
    };
    const filter = () => {
      const q = search.value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      [...list.children].forEach((li) => { li.hidden = q && !li.textContent.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').includes(q); });
      empty.hidden = items().length > 0;
      setActive(0);
    };
    const open = () => {
      if (select.disabled || !panel.hidden) return;
      render();
      search.value = '';
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      const sel = items().findIndex((li) => li.getAttribute('aria-selected') === 'true');
      setActive(sel > -1 ? sel : 0);
      if (!searchBox.hidden && !coarse.matches) search.focus(); else list.focus({ preventScroll: true });
    };
    const close = (focusBtn) => {
      if (panel.hidden) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      if (focusBtn) btn.focus();
    };
    const choose = (li) => {
      if (!li) return;
      select.value = li.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      render();
      close(true);
    };
    btn.addEventListener('click', () => (panel.hidden ? open() : close(true)));
    btn.addEventListener('keydown', (e) => { if (['ArrowDown', 'ArrowUp'].includes(e.key)) { e.preventDefault(); open(); } });
    list.addEventListener('click', (e) => choose(e.target.closest('[role="option"]')));
    list.addEventListener('mousemove', (e) => { const li = e.target.closest('[role="option"]'); if (li) setActive(items().indexOf(li)); });
    search.addEventListener('input', filter);
    wrap.addEventListener('keydown', (e) => {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') { e.preventDefault(); choose(items()[active]); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
      else if (e.key === 'Tab') close(false);
    });
    document.addEventListener('pointerdown', (e) => { if (!wrap.contains(e.target)) close(false); });
    // Optionen/Wert/disabled werden per JS geändert → neu zeichnen
    new MutationObserver(render).observe(select, { childList: true, attributes: true, attributeFilter: ['disabled'] });
    select.addEventListener('change', render);
    select.hwsRender = render;
    render();
  };

  /* ---------- Produktbilder beim Modellwechsel sofort da: Variantenbilder vorladen ----------
     Die Galerie zeigt nur die Bilder der gewählten Variante; andere kommen erst mit dem Wechsel.
     Darum laden wir sie vorab mit demselben srcset/sizes wie die Galerie – dann kommen sie aus dem Cache. */
  function initVariantMedia() {
    const data = document.querySelector('[data-hws-fit-variants]');
    const info = data && data.closest('product-info');
    if (!info || info.dataset.hwsMedia) return;
    info.dataset.hwsMedia = '1';
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    const urls = new Map();
    variants.forEach((v) => { if (v.m && v.u) urls.set(v.m, v.u); });
    if (urls.size < 2) return;
    const sample = info.querySelector('media-gallery .product__media img[srcset], .product__media-list img[srcset]');
    const widths = sample ? [...sample.srcset.matchAll(/[?&]width=(\d+)\s+(\d+)w/g)].map((m) => m[1]) : [];
    const sizes = sample ? sample.getAttribute('sizes') : '';
    const keep = [];
    const done = new Set();
    const load = (mediaId) => {
      const base = urls.get(mediaId);
      if (!base || done.has(mediaId) || !widths.length) return;
      done.add(mediaId);
      const sep = base.includes('?') ? '&' : '?';
      const img = new Image();
      img.decoding = 'async';
      if (sizes) img.sizes = sizes;
      img.srcset = widths.map((w) => `${base}${sep}width=${w} ${w}w`).join(', ');
      keep.push(img);
    };
    // Tipp/Hover auf ein Modell oder eine Farbe: genau dieses Bild sofort laden
    const onIntent = (event) => {
      const label = event.target.closest && event.target.closest('variant-selects label');
      const input = label && document.getElementById(label.htmlFor);
      if (!input) return;
      const fieldsets = [...info.querySelectorAll('variant-selects fieldset')];
      const idx = fieldsets.indexOf(input.closest('fieldset'));
      const current = fieldsets.map((fs) => (fs.querySelector('input:checked') || {}).value);
      if (idx > -1) current[idx] = input.value;
      const exact = variants.find((v) => v.o.every((val, i) => val === current[i]));
      const any = variants.find((v) => v.o[idx] === input.value && v.m);
      load((exact && exact.m) || (any && any.m));
    };
    info.addEventListener('pointerover', onIntent, { passive: true });
    info.addEventListener('touchstart', onIntent, { passive: true });
    info.addEventListener('focusin', onIntent);
    // Bei guter Verbindung alle Variantenbilder nach dem Laden der Seite holen
    const c = navigator.connection || {};
    if (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) return;
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
    const all = () => idle(() => [...urls.keys()].slice(0, 24).forEach(load));
    if (document.readyState === 'complete') all(); else window.addEventListener('load', all, { once: true });
  }

  /* ---------- WhatsApp „Frage zu diesem Teil?": Nachricht folgt der gewählten Ausführung ---------- */
  function initWhatsAppVariant() {
    const link = document.querySelector('[data-hws-wa]');
    if (!link || link.dataset.ready || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    link.dataset.ready = '1';
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const v = event && event.data && event.data.variant;
      if (!v) return;
      const product = v.title && v.title !== 'Default Title' ? `${link.dataset.product} (${v.title})` : link.dataset.product;
      const text = link.dataset.template.replace('__PRODUCT__', product).replace('__URL__', `${link.dataset.link}?variant=${v.id}`);
      link.href = `https://wa.me/${link.dataset.number}?text=${encodeURIComponent(text)}`;
    });
  }

  /* ---------- Zuletzt angesehen: Verlauf im Browser (nur mit Einwilligung „Präferenzen"), Preise frisch vom Shop ---------- */
  function initRecent() {
    const KEY = 'hws-recent';
    const box = document.querySelector('[data-hws-recent]');
    if (document.documentElement.dataset.hwsRecentInit) return;
    document.documentElement.dataset.hwsRecentInit = '1';
    const current = box && box.dataset.current;
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
    const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* privater Modus */ } };
    const wipe = () => {
      try { localStorage.removeItem(KEY); } catch (e) { /* egal */ }
      if (box) box.hidden = true;
    };
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      let list = read();
      if (current) { list = [current, ...list.filter((h) => h !== current)].slice(0, 12); write(list); }
      if (!box) return;
      const handles = list.filter((h) => h !== current).slice(0, 8);
      if (!handles.length) return;
      const esc = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      const render = async () => {
        const results = await Promise.all(handles.map((h) => fetch(`${box.dataset.root}products/${encodeURIComponent(h)}?view=hws-mini`)
          .then((r) => (r.ok ? r.text() : '')).then((txt) => { try { return JSON.parse(txt); } catch (e) { return null; } }).catch(() => null)));
        const products = results.filter(Boolean);
        // nicht mehr vorhandene Produkte aus dem Verlauf entfernen
        if (products.length < handles.length) {
          const alive = new Set(products.map((p) => p.handle));
          write(read().filter((h) => h === current || alive.has(h) || !handles.includes(h)));
        }
        if (!products.length) return;
        box.querySelector('[data-hws-recent-list]').innerHTML = products.map((p) => {
          const img = p.image ? (String(p.image).startsWith('//') ? `https:${p.image}` : p.image) : '';
          return `<li><a class="hws-recent__card" href="${esc(p.url)}">
            <span class="hws-recent__img">${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="160" height="160">` : ''}</span>
            <span class="hws-recent__name">${esc(p.title)}</span>
            <span class="hws-recent__price">${p.available ? esc(p.price) : `<span class="hws-recent__soldout">${esc(box.dataset.soldout)}</span>`}</span>
          </a></li>`;
        }).join('');
        box.classList.remove('is-pending');
        box.hidden = false;
      };
      // erst laden, wenn der Bereich in die Nähe kommt
      if ('IntersectionObserver' in window) {
        box.classList.add('is-pending');
        box.hidden = false;
        const io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          render();
        }, { rootMargin: '400px 0px' });
        io.observe(box);
      } else render();
      box.querySelector('[data-hws-recent-clear]').addEventListener('click', () => { write(current ? [current] : []); box.hidden = true; });
    };
    const decide = (allowed) => (allowed ? start() : wipe());
    const check = () => { try { decide(!!window.Shopify.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { decide(false); } };
    if (window.Shopify && window.Shopify.customerPrivacy) check();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => (error ? decide(false) : check()));
    } else decide(false);
    // Einwilligung später erteilt oder zurückgezogen (Cookie-Banner)
    document.addEventListener('visitorConsentCollected', (event) => decide(!!(event.detail && event.detail.preferencesAllowed)));
  }

  /* ---------- Benachrichtigen, wenn verfügbar: Dialog, Vorauswahl der Ausführung, Rückmeldung nach dem Absenden ---------- */
  function initRestock() {
    const root = document.querySelector('[data-hws-restock]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const dialog = root.querySelector('[data-hws-restock-dialog]');
    // Direkt unter <body>: im nicht-modalen Zustand (siehe Absenden) würde ein transformierter Vorfahre „fixed" verbiegen
    document.body.appendChild(dialog);
    const select = dialog.querySelector('[data-hws-restock-variant]');
    const email = dialog.querySelector('input[type="email"]');
    const field = (name) => dialog.querySelector(`[data-hws-restock-field="${name}"]`);
    const info = root.closest('product-info');
    const coarse = window.matchMedia('(pointer: coarse)');

    const syncFields = () => {
      const opt = select && select.selectedOptions[0];
      if (!opt) return;
      if (field('title')) field('title').value = opt.textContent.trim();
      if (field('sku')) field('sku').value = opt.dataset.sku || '';
      if (field('link')) field('link').value = `${field('link').dataset.base}?variant=${opt.value}`;
    };
    if (select && window.hwsEnhanceSelect) window.hwsEnhanceSelect(select, { search: root.dataset.search, empty: root.dataset.empty });
    const form = dialog.querySelector('form');
    const formNodes = form ? [...form.childNodes] : [];
    const open = (variantTitle) => {
      // nach einer Anmeldung (Erfolgsansicht) wieder das Formular – z. B. für eine zweite Ausführung
      if (form && form.dataset.done) {
        form.replaceChildren(...formNodes);
        delete form.dataset.done;
      }
      if (select && variantTitle) {
        const opts = [...select.options];
        // genau diese Ausführung – oder (wenn sie lieferbar ist) die erste ausverkaufte desselben Modells
        const model = variantTitle.split(' / ')[0];
        const match = opts.find((o) => o.textContent.trim() === variantTitle)
          || opts.find((o) => o.textContent.trim().split(' / ')[0] === model);
        if (match) select.value = match.value;
      }
      if (select && select.hwsRender) select.hwsRender();
      syncFields();
      dialog.showModal();
      document.documentElement.classList.add('hws-dialog-open');
      // Am Handy keine Tastatur und kein Fokusrahmen beim Öffnen: Fokus auf die Karte statt aufs erste Feld
      if (email && !coarse.matches && !email.value) email.focus();
      else dialog.querySelector('.hws-ui-card').focus({ preventScroll: true });
    };
    const close = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (reduceMotion) return dialog.close();
      dialog.classList.add('is-closing');
      setTimeout(() => { dialog.classList.remove('is-closing'); dialog.close(); }, 220);
    };

    root.querySelectorAll('[data-hws-restock-open]').forEach((btn) => btn.addEventListener('click', () => {
      const current = info && info.querySelector('variant-selects [data-selected-variant]');
      let title = '';
      try { title = current ? JSON.parse(current.textContent).title : ''; } catch (e) { /* ohne Vorauswahl */ }
      open(title);
    }));
    dialog.querySelectorAll('[data-hws-restock-close]').forEach((btn) => btn.addEventListener('click', close));
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    // „close" kommt asynchron – beim Wechsel auf nicht-modal ist der Dialog dann schon wieder offen
    dialog.addEventListener('close', () => {
      if (dialog.open) return;
      dialog.classList.remove('is-sending');
      document.documentElement.classList.remove('hws-dialog-open');
    });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    if (select) select.addEventListener('change', syncFields);
    // Anmeldung direkt bei Alert Me (App „Alert Me Restock“): die App verschickt die E-Mail automatisch,
    // sobald die Ausführung wieder auf Lager ist. Gleiche Anfrage wie Alert Mes eigenes Skript – das ist im Theme
    // abgeschaltet, weil es bei jedem Seitenaufruf die IP-Adresse an US-Dienste schickt. Prüfsumme: SHA-256 aus
    // dem öffentlichen Schlüssel in Alert Mes Skript, E-Mail, Produkt und Ausführung.
    const BIS_URL = 'https://backinstock.grootapps.com/api/back-in-stock/store';
    const BIS_KEY = '9f7d2c4a8e6b1f3a5c9e0d2b4a6f8e1c';
    const subscribeAlertMe = async () => {
      const abort = new AbortController();
      const timer = setTimeout(() => abort.abort(), 10000);
      try {
        const mail = email.value.trim();
        const pid = root.dataset.productId;
        const vid = (select && select.value) || root.dataset.variant;
        const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(`${BIS_KEY}|${mail}||${pid}|${vid}`));
        const token = Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
        const res = await fetch(BIS_URL, {
          method: 'POST',
          signal: abort.signal,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Shop-Domain': root.dataset.bisShop },
          body: JSON.stringify({
            shopify_product_id: pid,
            shopify_variant_id: vid,
            newsLetterSubscribe: false,
            email: mail,
            phone_number: null,
            phone: null,
            countryID: null,
            locale: root.dataset.bisLocale || 'de',
            customer: null,
            is_email_subscribed: true,
            is_sms_subscribed: false,
            is_whatsapp_subscribed: false,
            shopify_market_id: Number(root.dataset.bisMarket) || null,
            client_ip: null,
            product_title: root.dataset.productTitle,
            security_token: token,
            timestamp: Date.now(),
          }),
        });
        const data = await res.json().catch(() => ({}));
        return res.ok && data.success === true;
      } catch (error) {
        return false;
      } finally {
        clearTimeout(timer);
      }
    };
    const showDone = () => {
      const tpl = root.querySelector('[data-hws-restock-done-tpl]');
      if (!tpl) return;
      form.replaceChildren(tpl.content.cloneNode(true));
      form.dataset.done = '1';
      form.querySelectorAll('[data-hws-restock-close]').forEach((btn) => btn.addEventListener('click', close));
      const btn = form.querySelector('[data-hws-restock-close]');
      if (btn) btn.focus();
    };
    if (form) {
      // Ohne Alert-Me-Daten oder ohne Web-Crypto (sehr alte Browser): gleich der bisherige Weg per Kontaktformular
      let viaContactForm = !root.dataset.bisShop || !root.dataset.productId || !(window.crypto && crypto.subtle && window.TextEncoder);
      form.addEventListener('submit', (event) => {
        syncFields();
        if (!viaContactForm) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (dialog.classList.contains('is-busy')) return;
          const button = form.querySelector('[type="submit"]');
          dialog.classList.add('is-busy');
          if (button) button.disabled = true;
          subscribeAlertMe().then((ok) => {
            dialog.classList.remove('is-busy');
            if (button) button.disabled = false;
            if (ok) return showDone();
            // Alert Me nicht erreichbar oder Fehler: Anfrage geht wie früher als Nachricht an den Shop
            viaContactForm = true;
            if (form.requestSubmit) form.requestSubmit();
            else form.submit();
          });
          return;
        }
        // Shopify prüft das Formular per hCaptcha. Ein mögliches Rätsel liegt unter einem modalen Dialog
        // und wäre nicht anklickbar – darum beim Absenden auf einen nicht-modalen Dialog wechseln.
        if (dialog.matches(':modal')) {
          dialog.close();
          dialog.show();
          dialog.classList.add('is-sending');
        }
      }, true);
    }

    // Tipp auf ein ausgegrautes Modell: Formular mit genau dieser Ausführung öffnen
    if (info) {
      info.addEventListener('click', (event) => {
        const label = event.target.closest('variant-selects label');
        const input = label && document.getElementById(label.htmlFor);
        if (!input || !input.disabled || input.type !== 'radio') return;
        event.preventDefault();
        const fieldsets = [...info.querySelectorAll('variant-selects fieldset')];
        const values = fieldsets.map((fs) => (fs.querySelector('input:checked') || {}).value || '');
        const index = fieldsets.indexOf(input.closest('fieldset'));
        if (index > -1) values[index] = input.value;
        open(values.join(' / '));
      });
    }

    // Ausverkaufte Ausführung gewählt (z. B. nach Farbwechsel): großer Button statt Hinweiszeile
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const v = event && event.data && event.data.variant;
        if (v) root.dataset.state = v.available ? 'partial' : 'soldout';
      });
    }

    // Nach dem Absenden lädt Shopify die Seite neu: Bestätigung bzw. Fehler direkt wieder zeigen
    if (dialog.querySelector('[data-hws-restock-done], [data-hws-restock-error]')) {
      open('');
      if (/[?&]contact_posted=/.test(location.search)) {
        const url = new URL(location.href);
        url.searchParams.delete('contact_posted');
        history.replaceState(history.state, '', url.pathname + url.search);
      }
    }
  }

  /* ---------- Suche: Synonyme für die Vorschläge beim Tippen (Theme-Einstellungen → HWS24 Suche) ---------- */
  (() => {
    const map = new Map();
    String(window.hwsSynonyms || '').split(/\r?\n/).forEach((line) => {
      const [words, target] = line.split('=').map((x) => (x || '').trim().toLowerCase());
      if (!words || !target) return;
      words.split(',').map((w) => w.trim()).filter(Boolean).forEach((w) => map.set(w, target));
    });
    // Ganze Wörter ersetzen, Rest der Eingabe bleibt (z. B. „batterie iphone 13" → „akku iphone 13")
    window.hwsExpandSearch = (term) => {
      if (!map.size) return term;
      let out = ` ${String(term).toLowerCase()} `;
      map.forEach((target, word) => { out = out.split(` ${word} `).join(` ${target} `); });
      return out.trim();
    };
  })();

  function safe(fn, ...args) {
    try { fn(...args); } catch (error) { console.error('[HWS24]', error); }
  }

  function initAll(root = document) {
    safe(initImageRetry);
    safe(initReveal, root);
    safe(initAutoplay, root);
    safe(initTheme);
    safe(initLanguageToggle);
    safe(initAuthDialog);
    safe(initAccountMenu);
    safe(initMegaCategories);
    safe(initBackbar);
    safe(initGpsrVariant);
    safe(initRestock);
    safe(initWhatsAppVariant);
    safe(initVariantMedia);
    safe(initRecent);
    safe(initParallax);
    safe(initToTop);
    safe(initNavProgress);
    safe(endPreloader);
    requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.add('hws-ready')));
    initFadeImages(root);
    initUspBar(root);
    initCounters(root);
    safe(initDrift, root);
    safe(initRepairBooking, root);
    safe(initRepairFinder, root);
    safe(initRepairModel, root);
    initTabs(root);
    initSliders(root);
    initStickyAtc();
    initDelivery(root);
  }

  // Für nachgeladene Inhalte (z. B. Modell-Auswahl auf dem Handy, siehe hws-app.js)
  window.hwsInit = (root) => initAll(root);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  // Theme-Editor: Abschnitte nach dem Neuladen wieder verdrahten
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
